import React, { useEffect, useState } from 'react';
import Sidebar from '../components/ui/Sidebar';
import RoleView from '../components/ui/RoleView';
import API_URL from '../config';
import useScreenWidth from '../hooks/useScreenWidth';
import {FaUser, FaUserPlus, FaEye, FaEyeSlash } from 'react-icons/fa';

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [modalAgregar, setModalAgregar] = useState(false);
  const [nuevoUsuario, setNuevoUsuario] = useState('');
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [nuevoRole, setNuevoRole] = useState('user');
  const [modalResetPassword, setModalResetPassword] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [verPassword, setVerPassword] = useState(false);
  const [verConfirm, setVerConfirm] = useState(false);
  const [verNuevaPassword, setVerNuevaPassword] = useState(false);
  const [verConfirmarPassword, setVerConfirmarPassword] = useState(false);
  const [confirmarPassword, setConfirmarPassword] = useState('');

  const screenWidth = useScreenWidth();
  const [sidebarVisible, setSidebarVisible] = useState(screenWidth >= 768);

  const styles = {
    tableHeader: {
      backgroundColor: '#a3bac0',
      color: '#333',
      fontWeight: 'bold',
      padding: '15px',
    },
    tableRow: {
      backgroundColor: '#daeeeeff',
      color: '#333',
      padding: '12px',
    },
    tableRowAlt: {
      backgroundColor: '#f0fbfbff',
      color: '#333',
      padding: '12px',
    },
  };

  const recargarUsuarios = async () => {
    const res = await fetch(`${API_URL}/api/usuarios`);
    const data = await res.json();
    setUsuarios(data);
  };

  useEffect(() => {
    recargarUsuarios();
  }, []);

  const cambiarRole = async (id, username, nuevoRole) => {
    try {
      await fetch(`${API_URL}/api/usuarios/${id}/role`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ role: nuevoRole })
      });
      alert(`El usuario ${username} ha sido cambiado a rol "${nuevoRole}"`);
      recargarUsuarios();
    } catch (err) {
      alert('Error al cambiar el rol');
      console.error(err);
    }
  };

  const cambiarEstado = async (id, username, nuevoEstado) => {
    try {
      await fetch(`${API_URL}/api/usuarios/${id}/estado`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estado: nuevoEstado })
      });
      alert(`El usuario ${username} ha sido cambiado a estado "${nuevoEstado}"`);
      recargarUsuarios();
    } catch (err) {
      alert('Error al cambiar el estado');
      console.error(err);
    }
  };

  return (
    <RoleView allowedRole="admin">
      <div style={{ display: 'flex' }}>
        <Sidebar sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible} />
        <main
          style={{
            flex: 1,
            minHeight: '100vh',
            overflowX: 'auto',
            overflowY: 'visible',
            marginLeft: sidebarVisible ? '180px' : '0',
            padding: '2rem',
            backgroundColor: '#edf0f0',
            position: 'relative',
          }}
        >
         {/* Usuario + icono (arriba a la derecha) */}
          <div
            style={{
              position: 'absolute',
              top: '1.2rem',
              right: '2rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontFamily: "'Poppins', sans-serif",
              fontSize: '0.95rem',
              color: '#333',
              zIndex: 1001,
            }}
          >
            <FaUser
              style={{
                fontSize: '2.2rem',
                color: '#333',
                verticalAlign: 'middle',
              }}
            />
            <span>
              {localStorage.getItem('user')
                ? JSON.parse(localStorage.getItem('user')).username
                : 'Usuario'}
            </span>
          </div>

          {/* Título centrado */}
          <h2 style={{ textAlign: 'center', margin: '2.2rem auto 1.5rem' }}>Gestión de Usuarios</h2>
          <p
            style={{
              fontSize: '0.9rem',
              color: '#666',
              marginBottom: '1rem',
              textAlign: 'center'
            }}
          >
            Desliza horizontalmente para ver toda la tabla en dispositivos móviles.
          </p>

            {/* Botón hamburguesa (visible para todos) */}
          {!sidebarVisible && (
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <button
                onClick={() => setSidebarVisible(true)}
                style={{
                  background: '#1f3339',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '0.6rem 1.2rem',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                  minWidth: '150px',
                }}
              >
                ☰ Menú
              </button>
            </div>
          )}

          {/* Contenedor responsivo con tabla */}
          <div
            style={{
              overflowX: 'auto',
              width: '100%',
              borderRadius: '16px',
              boxShadow: '0 4px 12px rgba(0,0,0,.06)',
              background: '#fff',
              padding: '1.5rem',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.005)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,.06)';
            }}
          >
            <table style={{
              width: '100%',
              minWidth: '700px',
              borderCollapse: 'collapse',
              background: '#fff',
              tableLayout: 'fixed'
            }}>
              <thead>
                <tr>
                  <th style={styles.tableHeader}>Usuario</th>
                  <th style={styles.tableHeader}>Rol</th>
                  <th style={styles.tableHeader}>Estado</th>
                  <th style={styles.tableHeader}>Fecha Creación</th>
                  <th style={styles.tableHeader}>Restablecer Contraseña</th>
                </tr>
              </thead>
              <tbody>
                {usuarios.map((u, index) => (
                  <tr
                    key={u.id}
                    style={index % 2 === 0 ? styles.tableRow : styles.tableRowAlt}
                  >
                    <td style={{ padding: styles.tableRow.padding }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        maxWidth: '200px'
                      }}>
                        {u.username}
                      </div>
                    </td>
                    <td style={{ padding: styles.tableRow.padding }}>
                      <select
                        value={u.role}
                        onChange={(e) => cambiarRole(u.id, u.username, e.target.value)}
                        style={{
                          position: 'relative',
                          zIndex: 10,
                          width: '100%',
                          padding: '0.4rem 1rem',
                          fontSize: '0.95rem',
                          fontFamily: "'Poppins', sans-serif",
                          background: '#fff',
                          color: '#333',
                          border: '1px solid #ccc',
                          borderRadius: '30px',
                          cursor: 'pointer',
                          transition: 'all 0.25s ease',
                          overflow: 'visible',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.03)';
                          e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                        }}
                      >
                        <option value="user">Usuario</option>
                        <option value="admin">Administrador</option>
                      </select>
                    </td>
                    <td style={{ padding: styles.tableRow.padding }}>
                      <select
                        value={u.estado}
                        onChange={(e) => cambiarEstado(u.id, u.username, e.target.value)}
                        style={{
                          position: 'relative',
                          zIndex: 10,
                          width: '100%',
                          padding: '0.4rem 1rem',
                          fontSize: '0.95rem',
                          fontFamily: "'Poppins', sans-serif",
                          background: '#fff',
                          color: '#333',
                          border: '1px solid #ccc',
                          borderRadius: '30px',
                          cursor: 'pointer',
                          transition: 'all 0.25s ease',
                          overflow: 'visible',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'scale(1.03)';
                          e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                        }}
                      >
                        <option value="activo">Activo</option>
                        <option value="inactivo">Inactivo</option>
                      </select>
                    </td>
                    <td style={{ padding: styles.tableRow.padding }}>
                      {new Date(u.fecha_creacion).toLocaleDateString()}
                    </td>
                    <td style={{ padding: styles.tableRow.padding }}>
                      <button
                        onClick={() => {
                          setModalResetPassword(true);
                          setCurrentUserId(u.id);
                        }}
                        style={{
                          padding: '0.5rem 1rem',
                          backgroundColor: '#47b9b6',
                          color: '#fff',
                          borderRadius: '8px',
                          border: 'none',
                          cursor: 'pointer',
                          fontFamily: "'Poppins', sans-serif",
                          transition: 'all 0.3s ease',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#246361';
                          e.currentTarget.style.transform = 'scale(1.05)';
                          e.currentTarget.style.boxShadow = '0 6px 14px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#47b9b6';
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                        }}
                      >
                        Restablecer Contraseña
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Botón flotante + Agregar Usuario (solo admin) */}
          <RoleView allowedRole="admin">
            <button
              onClick={() => {
                setModalAgregar(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              style={{
                position: 'fixed',
                bottom: '2rem',
                right: '2rem',
                background: '#47b9b6',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: '60px',
                height: '60px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                cursor: 'pointer',
                zIndex: 999,
                transition: 'all 0.25s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#246361';
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#47b9b6';
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = 'scale(0.95)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = 'scale(1.1)';
              }}
              title="Agregar nuevo usuario"
            >
              <FaUserPlus size={24} />
            </button>
          </RoleView>

          {/* Modal restablecer contraseña */}
          {modalResetPassword && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
              }}
              onClick={() => {
                setModalResetPassword(false);
                setNewPassword('');
                setConfirmPassword('');
              }}
            >
              <div
                style={{
                  background: '#fff',
                  borderRadius: '12px',
                  padding: '2rem',
                  width: '90%',
                  maxWidth: '400px',
                  boxShadow: '0 8px 24px rgba(0,0,0,.15)',
                  textAlign: 'center'
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <h3>Restablecer Contraseña</h3>

                <label style={{ display: 'block', textAlign: 'left', marginBottom: '0.5rem' }}>
                  Nueva contraseña (10 caracteres):
                </label>
                <div style={{ position: 'relative', marginBottom: '1rem' }}>
                  <input
                    type={verPassword ? 'text' : 'password'}
                    maxLength={10}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '0.5rem 2.5rem 0.5rem 0.5rem',
                      fontSize: '1rem',
                      borderRadius: '8px',
                      border: '1px solid #ccc'
                    }}
                  />
                  <div
                    onClick={() => setVerPassword(!verPassword)}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#666',
                      fontSize: '1.2rem'
                    }}
                  >
                    {verPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>

                <label style={{ display: 'block', textAlign: 'left', marginBottom: '0.5rem' }}>
                  Confirmar contraseña:
                </label>
                <div style={{ position: 'relative', marginBottom: '1rem' }}>
                  <input
                    type={verConfirm ? 'text' : 'password'}
                    maxLength={10}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '0.5rem 2.5rem 0.5rem 0.5rem',
                      fontSize: '1rem',
                      borderRadius: '8px',
                      border: '1px solid #ccc'
                    }}
                  />
                  <div
                    onClick={() => setVerConfirm(!verConfirm)}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#666',
                      fontSize: '1.2rem'
                    }}
                  >
                    {verConfirm ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                  <button
                    onClick={() => {
                      setModalResetPassword(false);
                      setNewPassword('');
                      setConfirmPassword('');
                    }}
                    style={{
                      padding: '0.5rem 1.2rem',
                      backgroundColor: '#615e5c',
                      color: '#fff',
                      borderRadius: '8px',
                      border: 'none',
                      cursor: 'pointer',
                      fontFamily: "'Poppins', sans-serif",
                      transition: 'all 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#3e3b39';
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 6px 14px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#615e5c';
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }}
                  >
                    Cancelar
                  </button>

                  <button
                    onClick={async () => {
                      if (newPassword.length !== 10 || confirmPassword.length !== 10) {
                        alert('La contraseña debe tener exactamente 10 caracteres');
                        return;
                      }
                      if (newPassword !== confirmPassword) {
                        alert('Las contraseñas no coinciden');
                        return;
                      }
                      try {
                        await fetch(`${API_URL}/api/usuarios/${currentUserId}/reset-password`, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({ newPassword }),
                        });
                        alert('Contraseña restablecida correctamente');
                        setModalResetPassword(false);
                        setNewPassword('');
                        setConfirmPassword('');
                        recargarUsuarios();
                      } catch (err) {
                        alert('Error al restablecer la contraseña');
                        console.error(err);
                      }
                    }}
                    style={{
                      padding: '0.5rem 1.2rem',
                      backgroundColor: '#47b9b6',
                      color: '#fff',
                      borderRadius: '8px',
                      border: 'none',
                      cursor: 'pointer',
                      fontFamily: "'Poppins', sans-serif",
                      transition: 'all 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#246361';
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 6px 14px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#47b9b6';
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Modal agregar usuario */}
          {modalAgregar && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
              }}
              onClick={() => {
                setModalAgregar(false);
                setNuevoUsuario('');
                setNuevaPassword('');
                setConfirmarPassword('');
                setNuevoRole('user');
              }}
            >
              <div
                style={{
                  background: '#fff',
                  borderRadius: '12px',
                  padding: '2rem',
                  width: '90%',
                  maxWidth: '400px',
                  boxShadow: '0 8px 24px rgba(0,0,0,.15)',
                  textAlign: 'center'
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <h3>Agregar nuevo usuario</h3>

                <label style={{ display: 'block', textAlign: 'left', marginBottom: '0.5rem' }}>Nombre de usuario:</label>
                <input
                  type="text"
                  placeholder="Nombre de usuario"
                  value={nuevoUsuario}
                  onChange={(e) => setNuevoUsuario(e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', marginBottom: '1rem' }}
                />

                <label style={{ display: 'block', textAlign: 'left', marginBottom: '0.5rem' }}>
                  Contraseña (10 caracteres):
                </label>
                <div style={{ position: 'relative', marginBottom: '1rem' }}>
                  <input
                    type={verNuevaPassword ? 'text' : 'password'}
                    maxLength={10}
                    value={nuevaPassword}
                    onChange={(e) => setNuevaPassword(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '0.5rem 2.5rem 0.5rem 0.5rem',
                      fontSize: '1rem',
                      borderRadius: '8px',
                      border: '1px solid #ccc'
                    }}
                  />
                  <div
                    onClick={() => setVerNuevaPassword(!verNuevaPassword)}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#666',
                      fontSize: '1.2rem'
                    }}
                  >
                    {verNuevaPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>

                <label style={{ display: 'block', textAlign: 'left', marginBottom: '0.5rem' }}>
                  Confirmar contraseña:
                </label>
                <div style={{ position: 'relative', marginBottom: '1rem' }}>
                  <input
                    type={verConfirmarPassword ? 'text' : 'password'}
                    maxLength={10}
                    value={confirmarPassword}
                    onChange={(e) => setConfirmarPassword(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '0.5rem 2.5rem 0.5rem 0.5rem',
                      fontSize: '1rem',
                      borderRadius: '8px',
                      border: '1px solid #ccc'
                    }}
                  />
                  <div
                    onClick={() => setVerConfirmarPassword(!verConfirmarPassword)}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#666',
                      fontSize: '1.2rem'
                    }}
                  >
                    {verConfirmarPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>

                <label style={{ display: 'block', textAlign: 'left', marginBottom: '0.5rem' }}>Tipo de usuario:</label>
                <select
                  value={nuevoRole}
                  onChange={(e) => setNuevoRole(e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', marginBottom: '1rem' }}
                >
                  <option value="user">Usuario</option>
                  <option value="admin">Administrador</option>
                </select>

                <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                  <button
                    onClick={() => {
                      setModalAgregar(false);
                      setNuevoUsuario('');
                      setNuevaPassword('');
                      setConfirmarPassword('');
                      setNuevoRole('user');
                    }}
                    style={{
                      padding: '0.5rem 1.2rem',
                      backgroundColor: '#615e5c',
                      color: '#fff',
                      borderRadius: '8px',
                      border: 'none',
                      cursor: 'pointer',
                      fontFamily: "'Poppins', sans-serif",
                      transition: 'all 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#3e3b39';
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 6px 14px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#615e5c';
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }}
                  >
                    Cancelar
                  </button>

                  <button
                    onClick={async () => {
                      if (
                        !nuevoUsuario.trim() ||
                        !nuevaPassword.trim() ||
                        !confirmarPassword.trim()
                      ) {
                        alert('Por favor completa todos los campos antes de continuar');
                        return;
                      }

                      if (nuevaPassword.length !== 10 || confirmarPassword.length !== 10) {
                        alert('La contraseña debe tener exactamente 10 caracteres');
                        return;
                      }

                      if (nuevaPassword !== confirmarPassword) {
                        alert('Las contraseñas no coinciden');
                        return;
                      }

                      try {
                        await fetch(`${API_URL}/api/usuarios`, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/json' },
                          body: JSON.stringify({
                            username: nuevoUsuario.trim(),
                            password: nuevaPassword,
                            role: nuevoRole,
                          }),
                        });
                        alert(`Se ha agregado exitosamente el usuario ${nuevoUsuario}`);
                        setModalAgregar(false);
                        setNuevoUsuario('');
                        setNuevaPassword('');
                        setConfirmarPassword('');
                        setNuevoRole('user');
                        recargarUsuarios();
                      } catch (err) {
                        alert('Error al agregar usuario');
                        console.error(err);
                      }
                    }}
                    style={{
                      padding: '0.5rem 1.2rem',
                      backgroundColor: '#47b9b6',
                      color: '#fff',
                      borderRadius: '8px',
                      border: 'none',
                      cursor: 'pointer',
                      fontFamily: "'Poppins', sans-serif",
                      transition: 'all 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#246361';
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 6px 14px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#47b9b6';
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                    }}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </RoleView>
  );
};

export default Usuarios;